import { useState, useEffect } from "react";
import { Form, Button } from 'reactstrap';
import { APIMS } from "../../../../../../../config/apims";
import { APILA } from "../../../../../../../config/apila";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export default function ModalTambahPrilaku(props) {
  const token = localStorage.getItem("token");
  const [propsData, setProopsData] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const ascending = 1;

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };

  const id_user = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "");

  const [openIndikator, setOpenIndikator] = useState(false);
  const [selectedIndikatorLabel, setSelectedIndikatorLabel] = useState("");

  // Loader select
  const [loadingTA, setLoadingTA] = useState(false);
  const [loadingDimensi, setLoadingDimensi] = useState(false);
  const [loadingElement, setLoadingElement] = useState(false);
  const [loadingIndikator, setLoadingIndikator] = useState(false);
 
  // Data
  const [getDataTA, setGetDataTA] = useState([]);
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getElement, setGetElement] = useState([]);
  const [getIndikator, setGetIndikator] = useState([]);

  const initialForm = {
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_element_id: "",
    ysb_sub_element_id: "",
    description_anomaly: "",
    user_id: "",
  };

  // const [form, setForm] = useState({
  //   ysb_semester_id: "",
  //   ysb_dimensi_id:"",
  //   ysb_element_id: "",
  //   ysb_sub_element_id: "",
  //   description_anomaly: "",
  //   user_id:"",
  // });

  const [form, setForm] = useState(initialForm);

  const resetFormAdd = () => {
    setForm({
      ...initialForm,
      ysb_semester_id: props.selectedSemesterId || "",
    });

    setSelectedIndikatorLabel("");
    setOpenIndikator(false);

    setGetElement([]);
    setGetIndikator([]);
  };

  useEffect(() => {
    if (props.show) {
      resetFormAdd();
    }
  }, [props.show, props.selectedSemesterId]);

  const usedIndikatorIds = new Set(
    (props.usedIndikatorData || [])
      .map((item) => String(item?.ysb_sub_element_id || ""))
      .filter(Boolean)
  );

  const isIndikatorUsed = (id) => {
    return usedIndikatorIds.has(String(id));
  };

  useEffect(() => {
    if (props.selectedSemesterId) {
      setForm((prev) => ({
        ...prev,
        ysb_semester_id: props.selectedSemesterId,
      }));
    }
  }, [props.selectedSemesterId]);

  const GetResponseTA = async () => {
      setLoadingTA(true);
      try {
        // const response = await APILA.get(
        //   `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
        //   fetchParams
        // );

        const response = await APIMS.get(
          `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetDataTA(response?.data?.data || []);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat data",
        });
      } finally {
        setLoadingTA(false);
      } ;
  } 

  useEffect(() => {
      GetResponseTA();
  }, [])

  const GetResponseDimensi = async () => {
      const response = await APILA.get(
        `/api/access/dimensis?page=1&limit=1000&ascending=${ascending}&search=`,
        fetchParams
      );
    
     if (response?.status === 200) {
        const dims = (response.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
      }
  } 

  useEffect(() => {
      GetResponseDimensi();
  }, [])

  

  const GetResponseElement = async () => {
      setLoadingElement(true);
      try {
        const response = await APILA.get(
          `/api/access/elements/dimensis?page=1&limit=1000&ascending=${ascending}&search=&ysb_dimensi_id=${form?.ysb_dimensi_id}`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetElement(response?.data?.data || []);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat data",
        });
      } finally {
        setLoadingElement(false);
      } 
  }
  
  useEffect(() => {
    if (form?.ysb_dimensi_id) {
      GetResponseElement();
    } else {
      setGetElement([]);
    }
  }, [form?.ysb_dimensi_id]);

  const GetResponseIndikator = async () => {
      setLoadingIndikator(true);
      try {
        const response = await APILA.get(
          `/api/sub-elements?page=1&limit=1000&ascending=${ascending}&search=&id_element=${form?.ysb_element_id}`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetIndikator(response?.data?.data || []);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat data",
        });
      } finally {
        setLoadingIndikator(false);
      } 
  }

  useEffect(() => {
    if (form?.ysb_element_id) {
      GetResponseIndikator();
    } else {
      setGetIndikator([]);
    }
  }, [form?.ysb_element_id]);

  //  const handleChange = async (e) => {
  //   setForm({
  //     ...form,
  //     [e.target.name] : e.target.value,
  //   });
  // };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setForm((prev) => {
      if (name === "ysb_dimensi_id") {
        return {
          ...prev,
          ysb_dimensi_id: value,
          ysb_element_id: "",
          ysb_sub_element_id: "",
        };
      }

      if (name === "ysb_element_id") {
        return {
          ...prev,
          ysb_element_id: value,
          ysb_sub_element_id: "",
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });

    if (name === "ysb_dimensi_id") {
      setSelectedIndikatorLabel("");
      setOpenIndikator(false);
      setGetElement([]);
      setGetIndikator([]);
    }

    if (name === "ysb_element_id") {
      setSelectedIndikatorLabel("");
      setOpenIndikator(false);
      setGetIndikator([]);
    }
  };
    

  const handleSubmit = useMutation(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (isIndikatorUsed(form?.ysb_sub_element_id)) {
      ToastError.fire({
        icon: "error",
        title: "Indikator ini sudah pernah dipilih.",
      });

      setIsSubmitting(false);
      return;
    }

    try {
      const response = await APILA.post("/api/config-anomalys/store-all", {
        ysb_semester_id: form?.ysb_semester_id,
        ysb_sub_element_id: form?.ysb_sub_element_id,
        description_anomaly: form?.description_anomaly,
        user_id: id_user,
      }, fetchParams);
      
      // if (response?.status === 200) {
      //   ToastSuccess.fire({
      //     icon: 'success',
      //     title: response.data.message,
      //   })
      //   props.GetResponseData();
      //   props.onHide();
      // }
      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
        });

        resetFormAdd();

        await props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
  <div className="modal">

    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>  

      <div className="d-flex header-modal">
        <h5>Tambah Perilaku</h5>

        <div className="ml-auto x-close">
          {/* <FontAwesomeIcon icon={faXmark} onClick={() => setProopsData(props.onHide)} /> */}
            <FontAwesomeIcon
            icon={faXmark}
            onClick={() => {
              resetFormAdd();
              props.onHide();
            }}
          />
        </div>
      </div>
      <hr/>

      <Modal.Body className="modal-body">
      <Form onSubmit={(e) => handleSubmit.mutate(e)}  >

          <div className="mt-2">
              <label className="label-form">Semester</label>
              <select
                aria-label="Default select example"
                name="ysb_semester_id"
                onChange={handleChange}
                value={form?.ysb_semester_id}
                className="select-form"
                // disabled={loadingTA}
                 disabled={loadingTA || !!props.selectedSemesterId}
              >
                <option value="" disabled>
                  {loadingTA ? "Memuat data..." : "Pilih Semester.."}
                </option>
                {getDataTA.map((row, index) => (
                  <option key={index} value={row?.id}>
                    {row?.name_year} (Semester {row?.semester})
                  </option>
                ))}
              </select>
          </div>

          <div className="mt-2" >
            <label className="label-form">Dimensi</label>
            <select
                aria-label="Default select example"
                name="ysb_dimensi_id"
                onChange={handleChange}
                value={form?.ysb_dimensi_id}
                className="select-form"
                disabled={loadingDimensi}
            >
              <option value="" disabled>
                  {loadingDimensi ? "Memuat data..." : "Pilih Dimensi.."}
              </option>
              {getDataDimensi.map((row, index) => (
                <option key={index} value={row?.id}>
                  {row.name_dimensi}
                </option>
              ))}
            </select>
          </div>

          <div className="mt-2">
              <label className="label-form">Element</label>
              <select
                aria-label="Default select example"
                onChange={handleChange}
                name="ysb_element_id"
                value={form?.ysb_element_id}
                className="select-form"
                disabled={!form?.ysb_dimensi_id || loadingElement} 
              >
                <option value="" disabled>
                  {!form?.ysb_dimensi_id
                    ? "Pilih dimensi dulu.."
                    : loadingElement
                    ? "Memuat data..."
                    : "Pilih Element.."}
                </option>
                {getElement.map((row, index) => (
                  <option key={index} value={row?.id}>
                    {row.description}
                  </option>
                ))}        
              </select>
            </div>

            <div className="mt-2">
              <label className="label-form">Indikator</label>

              <div className="custom-select-wrapper">
                <button
                  type="button"
                  className="custom-select-trigger"
                  onClick={() => setOpenIndikator(!openIndikator)}
                  disabled={!form?.ysb_element_id || loadingIndikator}
                >
                  {selectedIndikatorLabel ||
                    (!form?.ysb_element_id
                      ? "Pilih element dulu.."
                      : loadingIndikator
                      ? "Memuat data..."
                      : "Pilih Indikator..")}
                </button>

                {openIndikator && (
                  <div className="custom-select-dropdown">
                    {/* {getIndikator.map((row, index) => (
                      <div
                        key={index}
                        className="custom-select-option"
                        onClick={() => {
                          setForm((prev) => ({
                            ...prev,
                            ysb_sub_element_id: row.id,
                          }));
                          setSelectedIndikatorLabel(row.description);
                          setOpenIndikator(false);
                        }}
                      >
                        {row.description}
                      </div>
                    ))} */}
                    {getIndikator.map((row, index) => {
  const disabled = isIndikatorUsed(row?.id);

  return (
    <div
      key={index}
      className={`custom-select-option ${disabled ? "option-disabled" : ""}`}
      style={{
        opacity: disabled ? 0.45 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor: disabled ? "#f3f4f6" : "#fff",
        color: disabled ? "#8b8b8b" : "inherit",
        pointerEvents: disabled ? "none" : "auto",
      }}
      onClick={() => {
        if (disabled) return;

        setForm((prev) => ({
          ...prev,
          ysb_sub_element_id: row.id,
        }));

        setSelectedIndikatorLabel(row.description);
        setOpenIndikator(false);
      }}
    >
      <span>{row.description}</span>

      {disabled && (
        <small
          style={{
            marginLeft: 8,
            color: "#dc3545",
            fontWeight: 600,
          }}
        >
          Sudah dipilih
        </small>
      )}
    </div>
  );
})}
                  </div>
                )}
              </div>
            </div>


          <div className="input-group mt-4 label-group-form-area">
              <label className="label-name-form">Perilaku</label>
              <textarea
                className="form-control"
                name="description_anomaly"
                value={form.description_anomaly}
                onChange={handleChange}
                aria-label="With textarea"
              />
            </div>

         
        <div className="d-flex mb-4">
            <div className="ml-auto">
              <Button
                className="mt-4 btn-modal-create"
                type="submit"
                disabled={isSubmitting}
                style={{
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  }}
              >
                {isSubmitting ? (
                  <span>
                    <i className="fa fa-spinner fa-spin mr-2" />
                    Menyimpan...
                  </span>
                  ) : (
                    "Tambahkan"
                  )}
              </Button>
            </div>
          </div>
        </Form>
        
      </Modal.Body>
    </Modal>
    </div> 
  );
}
  